import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledGeneralTableBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  width: '100%',
  overflowX: 'auto',
  overflowY: 'auto',
  flexDirection: 'column',
  justifyContent: 'flex-start',
  alignItems: 'stretch',
  backgroundColor: theme.palette.background.formTables,
  minHeight: { xs: '40em', md: '50em' },
  '& table': {
    tableLayout: 'auto',
    width: 'auto',
    minWidth: 'max-content',
  },
  '& th, & td': {
    whiteSpace: 'nowrap',
    width: 'auto',
  },
  '*::-webkit-scrollbar': {
    width: '8px',
    height: '8px',
  },
  '*::-webkit-scrollbar-track': {
    background: 'inherit',
    boxShadow: 'inset 0 0 6px rgba(0, 0, 0, 0.3)',
  },
  '*::-webkit-scrollbar-thumb': {
    backgroundColor: 'gray',
    borderRadius: '20px',
  },
  '*::-webkit-scrollbar-corner': {
    background: 'inherit',
  },
}));

const GeneralTableBox = ({ children, sx = {}, ...props }) => {
  return (
    <StyledGeneralTableBox sx={sx} {...props}>
      {children}
    </StyledGeneralTableBox>
  );
};

export default GeneralTableBox;
